import { Flex, Image, useBreakpointValue } from '@chakra-ui/react';
import { HStack } from '@ayble-health/dashboard-components';

const logo = "../../FA__ayble_health_Logo_Isabelline_white.png";

export const Header = () => {
  const isMobile = useBreakpointValue({
    base: true,
    sm: false,
  });

  return (
    <Flex
      alignItems={isMobile ? "center" : undefined}
      bgColor={"secondary.500"}
      direction={isMobile ? "column" : "row"}
      height={isMobile ? undefined : 128}
      justifyContent={"space-between"}
      px={6}
    >
      <HStack>
        <Image
          alt="Ayble Health logo"
          fit={"contain"}
          boxSize={"96px"}
          src={logo}
          data-testid={"ayble-health-logo"}
        />
      </HStack>
    </Flex>
  );
};
